var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8594 23.0575C25.188 27.2245 20.5199 29.9884 15.2055 29.9999C6.97232 30.0178 0.212066 23.358 0.112516 15.1254C0.0188827 7.37918 5.77402 0.957478 13.2391 0.00157976C13.3986 -0.0188695 13.5026 0.16365 13.4056 0.29197C11.6057 2.67445 10.5386 5.64076 10.5386 8.85703C10.5386 16.7123 16.9063 23.08 24.7615 23.08C25.7578 23.08 26.7298 22.9778 27.6682 22.7826C27.8257 22.7498 27.9462 22.922 27.8594 23.0575Z",
    fill: "#64AB92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6685 22.7823C27.8258 22.7496 27.9462 22.9214 27.8596 23.0566C25.1827 27.2327 20.5007 29.9999 15.1724 29.9999C6.85413 29.9999 0.111633 23.2568 0.111633 14.9392C0.111633 11.6106 1.19116 8.53454 3.01993 6.04114C2.60474 7.40315 2.37769 8.84708 2.36861 10.343C2.31781 18.7238 9.04882 25.4974 17.4298 25.4971C20.4667 25.497 23.2936 24.5981 25.6585 23.0514C26.3431 23.0092 27.014 22.9185 27.6685 22.7823Z",
    fill: "#429E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.1e07a253d7955d4c636481b875f7b534.svg";
export { ForwardRef as ReactComponent };